import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/test.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { selectUserDetails } from "../../redux/features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { signOutSubmit } from "../../redux/features/auth/authService";
import { showToast } from "../ToastMsg";

const pages = [
    { name: "Home", path: "/" },
    { name: "Courses", path: "#courses" },
    { name: "About Us", path: "#about" },
    { name: "Contact", path: "#contact" }
];

const Sidebar = ({ isSidebarOpen, closeSidebar }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { hasCheckedAuth, details } = useSelector(selectUserDetails);

    const toggleLogin = () => navigate('/auth/login');
    const toggleReg = () => navigate('/auth/register');

    useEffect(() => {
        document.addEventListener("mousedown", closeSidebar);
        return () => {
            document.removeEventListener("mousedown", closeSidebar);
        };
    }, []);

    const handleLogout = () => {
        dispatch(signOutSubmit())
            .unwrap()
            .then(() => {
                navigate('/');
            })
            .catch((error) => {
                showToast("error", error.message);
            });
    }

     const handleNavigation = (e, path) => {
        if (path.startsWith("#")) {
            e.preventDefault();

            const sectionId = path.replace("#", "");
            const element = document.getElementById(sectionId);
            if (location.pathname === "/") {
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            } else {
                navigate(`/${path}`);
            }
        }
        else if (path === "/" && location.pathname === "/") {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className={`${styles.sideBarContainer} ${isSidebarOpen ? styles.showSidebar : styles.hideSidebar
                }`}>
                <div className={styles.headingSec}>
                    <div className={styles.logoSec}>
                        <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                    </div>
                    <div className={styles.topSec}>
                        <div className={styles.barIcon} onClick={closeSidebar}>
                            <FontAwesomeIcon icon={faBars} size="lg" style={{ color: '#1D0C50', marginTop: '0px' }} />
                        </div>
                    </div>
                </div>
                {hasCheckedAuth && (
                    details.id ? (
                        <></>
                    ) : (
                        <div className={styles.btnSec}>
                            <button type="button" className={styles.loginBtn} onClick={toggleLogin}>Login</button>
                            <button type="button" className={styles.regBtn} onClick={toggleReg}>Register</button>
                        </div>
                    )
                )}
                <ul className={styles.sidebarMenu}>
                    {pages.map(({ name, path }) => (
                        <li key={name}>
                            <NavLink to={path} className={({ isActive }) =>
                                `${isActive ? styles.active : ""}`
                            }
                            onClick={(e) => handleNavigation(e, path)}>
                                {name}
                            </NavLink>
                        </li>
                    ))}
                    {hasCheckedAuth && (
                        details.id && (
                            <>
                                <li>
                                    <NavLink to={'/my-profile'} className={({ isActive }) =>
                                        `${isActive ? styles.active : ""}`
                                    }>
                                        Profile
                                    </NavLink>
                                </li>
                                <li onClick={handleLogout} className={styles.dropdownItem}>
                                    Logout
                                </li>
                            </>
                        ))}
                </ul>
            </div>
        </>
    );
};

export default Sidebar;
